import { LibraryConfig } from '../types/LibraryConfig';
import { APP_CATEGORIES } from '@/config/settings';
import { deleteAiApp } from '@/services/aiApps';

export const aiAppsConfig: LibraryConfig = {
  entityType: 'app',
  displayName: 'App',
  pluralName: 'Apps',

  pageMeta: {
    eyebrow: 'AI APP STORE',
    title: 'Explore AI Apps',
    description:
      'Here, you can find AI Apps that can save you time, support your thinking and help with everyday tasks.',
  },

  groupTypes: ['Global AI Apps', 'AI App Marketplace', 'My AI Apps', 'Shared with Me'],
  groupDisplayNames: ['Apps by Informa', 'Apps by Colleagues', 'Created by Me', 'Shared with Me'],
  defaultGroup: 'Global AI Apps',

  categories: APP_CATEGORIES,

  emptyMessages: {
    'My AI Apps-All': 'Create an App to see it in this list and share it with others.',
    'Shared with Me-All': 'No apps have yet been shared with you.',
    'AI App Marketplace-All': 'No apps yet published.',
    default: 'No apps found.',
  },

  dropDownOptions: [
    'Alphabetical (A-Z)',
    'Alphabetical (Z-A)',
    'Highest Rated',
    'Most Used',
    'Newest',
  ],

  banner: {
    heading: 'Turn repeated tasks into tools.',
    description: 'Make workflows reusable with AI apps. Create, reuse, and share.',
    primaryAction: {
      label: 'Build your own AI App',
      href: '/app-builder',
    },
  },

  createdByMeGroup: 'My AI Apps',
  searchOption: true,
  searchPlaceholder: 'Search Apps by Name, Description or Creator',

  card: {
    showRating: true,
    showFavourite: true,
    showCategoryBadge: false,
  },

  modal: {
    showRating: true,
    showSessions: true,
  },

  remove: {
    deleteFn: async (appId) =>
      (await deleteAiApp(appId))?.data?.message == 'Agent is deleted successfully',
  },

  showSortDropdown: true,
};
